
require('prelude');

const $ = require('jquery');
const _ = require('lodash');

const Controller = require('./js/controller.js');

import * as templates from './templates/*';

const GTM_PROCESSING_CONFIG_SELECTOR = '#form-insurance-application-gtm-processing-config';

const pushConversionChuteEvent = require('push-conversion-chute-event');

module.exports = {
	createForModal: function (e, options) {
		let tmpl = '';
		_.each(templates, function (template){
			tmpl += template();
		});

		const gtmProcessingJSON = $(GTM_PROCESSING_CONFIG_SELECTOR).html();
		const gtmProcessingConfig = (gtmProcessingJSON) ? JSON.parse(gtmProcessingJSON) : {};
		options.gtmProcessingConfig = gtmProcessingConfig;
		options.pushConversionChuteEvent = pushConversionChuteEvent;

		pushConversionChuteEvent(gtmProcessingConfig.initBtnClick);

		const contr = Controller(options);

		pushConversionChuteEvent(gtmProcessingConfig.init);

		return {
			title: contr.model.AppTitle,
			template: {
				nodes: $.parseHTML(tmpl),
				data: contr.model,
			},
		};
	},
};
